var React = require('react');

function Messenger (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.59 19.95L13.52 15.6L5.57 19.95L14.31 10.67L18.48 15.02L26.33 10.67L17.59 19.95ZM16 0C7.16 0 0 6.63 0 14.82C0 19.48 2.33 23.64 5.96 26.36V32L11.41 29.01C12.9051 29.4222 14.4491 29.6307 16 29.63C24.84 29.63 32 23 32 14.81C32 6.63 24.84 0 16 0V0Z","fill":"black"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"32","height":"32","fill":"white"})))]);
}

Messenger.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Messenger;

Messenger.default = Messenger;
